// removed by extract-text-webpack-plugin
module.exports = {"listing":"_1k4_d _2Em4n _1wiTN _1gKwo _2h9Fs","undo":"_14p1j _17V2F _2z9kb _2zlem Wr_al _26OGD _18-EI _38618 _3Dqep","actions":"yvUyo _38618 _3Dqep VW9bs","undoButton":"_318oQ _1ABq6 _3l3zl _3TD8R","dismissButton":"lsc_S _1a-AI"};


//////////////////
// WEBPACK FOOTER
// ./containers/UndoListing.css
// module id = 1977
// module chunks = 3